module.exports = __webpack_public_path__ + "static/media/img89.919ed771.jpg";